/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*************************************************************************************** */
// Original uso AdvanceTable.

// import { faPlus } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import PageBreadcrumb from 'components/common/PageBreadcrumb';
// import ProjectsTopSection from 'components/modules/project-management/ProjectsTopSection';
// import ProjectListTable, {
//     projectListTableColumns
// } from 'components/tables/ProjectListTable';
// import { defaultBreadcrumbItems } from 'data/commonData';
// import { projects } from 'data/project-management/projects';
// import useAdvanceTable from 'hooks/useAdvanceTable';
// import AdvanceTableProvider from 'providers/AdvanceTableProvider';
// import { Link } from 'react-router-dom';

import React, { forwardRef, useEffect, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


// import 'primereact/resources/themes/saga-blue/theme.css';
// import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable } from 'primereact/datatable';
import { Column, ColumnFilterElementTemplateOptions } from 'primereact/column';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';

import '../../App.css'

import { getConditionBgClass, ModeFormProps, parseDate } from './Utils';
import { InspectionRoute } from 'data/entities/InspectionRoute';
import { getDateLocaleConfig } from 'i18n/locale';

import { ptBR, enUS } from 'date-fns/locale';
import DatePicker, { registerLocale } from "react-datepicker";
import { FaCalendarAlt } from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import { DatabaseService } from './stores/DatabaseService';
import dayjs from 'dayjs';
registerLocale('pt-BR', ptBR)
registerLocale('en-US', enUS)

interface Equipment {
    id: number;
    order: number;
    code: string;
    name: string;
    condition?: string | null;
    fase: string | null;
    delta_t?: string | null;
    date?: string | null;
}

interface Condition {
    condition: number;
    name: string;
}

const InspectionRouteForm = ({ mode }: ModeFormProps) => {
    const { i18n } = useTranslation();
    const dateLocale = getDateLocaleConfig(i18n.language);
    const pickerLocale = dateLocale.datePickerLocale;
    const pickerDateFormat = dateLocale.datePickerFormat;
    const pickerPlaceholder = dateLocale.datePickerPlaceholder;

    const dbService = DatabaseService.getInstance();
    const [equipmentsArray, setEquipmentsArray] = useState<any[]>([]);
    const thermographers = dbService.getThermographers();

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [selectedEquipment, setSelectedEquipment] = useState<any>(null);
    const [equipments, setEquipments] = useState<any[]>([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [conditions] = useState<Condition[]>(
        [
            { condition: 1, name: '\u200BNormal' },
            { condition: 2, name: '\u200CBaixo Risco' },
            { condition: 3, name: '\u200DMédio Risco' },
            { condition: 4, name: '\u200EAlto Risco' },
            { condition: 5, name: '\u200BFlto Risco Iminente' },
        ]
    )

    const [formData, setFormData] = useState<InspectionRoute>({
        id: 0,
        route_number: '',
        closed: null,
        datetime: '',
        plan_note: '',
        deadlineExecution: '',
        asset_number: '',
        thermographer: '',
        power_station_id: ''
    });
    const [isEditMode, setIsEditMode] = useState(false);
    const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        const equipmentsArray = dbService.getEquipments();
        setEquipmentsArray(equipmentsArray);
    }, [dbService.isInitialized])

    useEffect(() => {
        const items = new Array<Equipment>();
        let order = 1;

        for (const item of equipmentsArray) {
            const equipment: Equipment = {
                id: item.external_code,
                order: order,
                code: item.code,
                name: item.title,
                condition: order % 5 == 0 ? condition[(Math.floor(Math.random() * 5) + 1)] : "Normal",
                fase: null,
                delta_t: order % 5 == 0 ? `${(Math.floor(Math.random() * 30))} °C` : null,
                date: order % 5 == 0 ? "23/02/2025" : null
            };
            items.push(equipment)
            order++;
        }
        const equipmentsFiltered = items.filter(item => item.code.includes('N-S-MAIZ'));
        setEquipments(equipmentsFiltered);
    }, [equipmentsArray]);

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Procurar por..." />
                </IconField>
            </div>
        );
    };

    const header = renderHeader();

    const condition: Record<number, any> = {
        //green
        1: "Normal",

        // 'Blue'
        2: "Baixo Risco",

        //'yellow',
        3: "Médio Risco",

        //'orange',
        4: "Alto Risco",

        //'red'
        5:
            "Alto Risco Iminente"

    };

    const conditionBodyTemplate = (rowData: any) => {
        const condition = rowData?.condition;

        if (condition === "Normal" || !condition) {
            return <div>{condition ?? "--"}</div>;
        }

        const bgClass = getConditionBgClass(condition);
        return <div className={`cell-content ${bgClass}`}>{condition}</div>;
    };

    const conditionsItemTemplate = (option: Condition) => {
        return (
            <div className="">
                <span>{option.name}</span>
            </div>
        );
    };

    const conditionRowFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return (
            <MultiSelect
                value={options.value}
                options={conditions}
                itemTemplate={conditionsItemTemplate}
                onChange={(e: { value: MultiSelectChangeEvent; }) => options.filterApplyCallback(e.value)}
                optionLabel="Condição"
                placeholder="Any"
                className="p-column-filter"
                maxSelectedLabels={1}
            />
        );
    };

    interface CustomInputProps {
        value?: string;
        onClick?: () => void;
        placeholder?: string;
    }

    const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
        ({ value, onClick, placeholder }, ref) => (
            <div style={{ position: 'relative', width: '100%' }}>
                <input
                    ref={ref}
                    type="text"
                    value={value}
                    onClick={onClick}
                    placeholder={placeholder}
                    style={{
                        paddingRight: '30px', // Espaço para o ícone
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: '1px solid #ced4da',
                        fontSize: '13px',
                    }}
                />
                <FaCalendarAlt
                    onClick={onClick}
                    style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        color: '#6c757d',
                    }}
                />
            </div>
        )
    );

    /************************************** Inspection Route Form *********************************/

    const validateForm = (): boolean => {
        const errors: { [key: string]: string } = {};
        if (!formData.route_number.trim()) {
            errors.route_number = 'Rota é obrigatória.';
        }
        if (!formData.thermographer) {
            errors.thermographer = 'Termografista é obrigatório.';
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'datetime' || name === 'deadlineExecution' ? dayjs(value).toDate() : value
        }));
    };

    const isValidDate = (date: Date) => {
        return date instanceof Date && !isNaN(date.getTime());
    };

    const handleDateChange = (date: Date | null) => {
        setFormData(prev => ({
            ...prev,
            datetime: date ? dayjs(date).format('YYYY-MM-DD') : ''
        }));
    };

    const handleDateLimitChange = (date: Date | null) => {
        setFormData(prev => ({
            ...prev,
            deadlineExecution: date ? dayjs(date).format('YYYY-MM-DD') : ''
        }));
    };

    const saveRoute = () => {
        if (!validateForm()) {
            alert('Not valid')
            return;
        }

        // if (isEditMode) {
        //     setInspectionRoutes(prev =>
        //         prev.map(r => (r.id === formData.id ? formData : r))
        //     );
        // } else {
        //     const newId = inspectionRoutes.length > 0 ? Math.max(...inspectionRoutes.map(r => r.id)) + 1 : 1;
        //     setInspectionRoutes(prev => [...prev, { ...formData, id: newId }]);
        // }
        // setModalVisible(false);
    };

    return (
        <div className="ms-3 mt-3 p-4 card" style={{ width: '98%' }}>
            <h4 className="mb-5 mt-3 ps-4">Roteiro de Inspeção Termográfica </h4>

            <Form onSubmit={(e) => { e.preventDefault(); saveRoute(); }}>
                <Row className="mb-3 gx-3">
                    <Form.Group as={Col} md="4" controlId="route_number" className="position-relative">
                        <Form.Label>Identificação da Rota*</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Rota"
                            name="route_number"
                            value={formData.route_number}
                            onChange={onInputChange}
                        // isInvalid={!!formErrors.route_number}
                        // isValid={formErrors.route_number === undefined && formData.route_number !== ''}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formErrors.route_number}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="plan_note" className="position-relative">
                        <Form.Label>Nro. da Nota do Plano</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Nota do Plano"
                            name="plan_note"
                            value={formData.plan_note || ''}
                            onChange={onInputChange}
                        // isInvalid={!!formErrors.plan_note}
                        // isValid={formErrors.plan_note === undefined && formData.plan_note !== ''}
                        />
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="thermographer" className="position-relative">
                        <Form.Label>Termografista*</Form.Label>

                        <Form.Select
                            name="thermographer"
                            value={formData.thermographer}
                            onChange={onInputChange}
                            required
                        >
                            <option value="">Selecione um Termografista</option>
                            {thermographers.map((thermographer) => (
                                <option key={thermographer.id} value={thermographer.id}>
                                    {thermographer.name}
                                </option>
                            ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                            {formErrors.thermographer}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="datetime" className="position-relative">
                        <Form.Label>Data de Início da Rota</Form.Label>
                        <Form.Group>
                            <DatePicker
                                key={`route-start-${i18n.language}`}
                                locale={pickerLocale}
                                selected={formData.datetime != null ? (() => {
                                    const d = parseDate(formData.datetime);
                                    if (!d || !isValidDate(d)) {
                                        console.error('Invalid date from parseDate for datetime:', formData.datetime);
                                        return null;
                                    }
                                    return d;
                                })() : new Date()}
                                onChange={handleDateChange}
                                dateFormat={pickerDateFormat}
                                placeholderText={pickerPlaceholder}
                                customInput={<CustomInput placeholder={pickerPlaceholder} />} className="form-control"
                            />
                        </Form.Group>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="deadlineExecution" className="position-relative">
                        <Form.Label>Data de Encerramento da Rota</Form.Label>
                        <Form.Group className="position-relative">
                            <DatePicker
                                key={`route-end-${i18n.language}`}
                                locale={pickerLocale}
                                selected={formData.deadlineExecution != null ? (() => {
                                    const d = parseDate(formData.deadlineExecution);
                                    if (!d || !isValidDate(d)) {
                                        console.error('Invalid date from parseDate for deadlineExecution:', formData.deadlineExecution);
                                        return null;
                                    }
                                    return d;
                                })() : new Date()}
                                onChange={handleDateLimitChange}
                                dateFormat={pickerDateFormat}
                                placeholderText={pickerPlaceholder}
                                customInput={<CustomInput placeholder={pickerPlaceholder} />} className="form-control"
                            />
                        </Form.Group>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="closed" className="position-relative">
                        <Form.Group>
                            <Form.Label>Rota Encerrada?</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Finalizar Rota"
                                checked={!!formData.closed}
                                onChange={(e) => setFormData(prev => ({ ...prev, closed: e.target.checked }))}
                            />
                        </Form.Group>
                    </Form.Group>

                    {/* <Form.Group as={Col} md="3" controlId="asset_number" className="position-relative">
                            <Form.Label>Patrimônio</Form.Label>
                            <Form.Control
                                type="text"
                                name="asset_number"
                                value={formData.asset_number || ''}
                                onChange={onInputChange}
                            /> 
                        </Form.Group>*/}
                </Row>


                <DataTable
                    value={equipments}
                    tableStyle={{ minWidth: '50rem' }}
                    size="small"
                    //showGridlines={true}
                    stripedRows
                    sortMode="multiple"
                    removableSort
                    //sortField="category" sortOrder={-1}
                    scrollable scrollHeight="600px"

                    selectionMode="single"
                    selection={selectedEquipment}
                    onSelectionChange={(e) => setSelectedEquipment(e.value)}
                    dataKey="order"

                    //reorderableColumns 
                    reorderableRows
                    onRowReorder={(e) => setEquipments(e.value)}

                    header={header}
                    filters={filters}
                    filterDisplay="row"
                    globalFilterFields={
                        ['code',
                            'name',
                            'condition'
                        ]
                    }
                    emptyMessage="Equipamento não encontrado."

                >
                    <Column rowReorder style={{ width: '2rem' }} />
                    <Column sortable field="order" header="Item"></Column>
                    <Column sortable field="code" header="Subestação / Função de Transmissão / Módulo"></Column>
                    <Column sortable field="name" header="Equipamento"></Column>
                    {/* <Column sortable field="condition" header="Condição" body={conditionBodyTemplate} filter filterElement={conditionRowFilterTemplate} ></Column> */}
                    <Column
                        sortable
                        field="condition" header="Condição" body={conditionBodyTemplate} >

                    </Column>
                    <Column sortable field="fase" header="Fase"></Column>
                    <Column sortable field="delta_t" header="Delta T"></Column>
                    <Column sortable field="date" header="Data"></Column>
                </DataTable>
            </Form>

        </div>
    );
};

export default InspectionRouteForm;
